export default "__VITE_ASSET__C5_1AZ0J__"